import React from "react";
import { Typography } from "@mui/material";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import RequestQuoteOutlinedIcon from "@mui/icons-material/RequestQuoteOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import FolderOpenOutlinedIcon from "@mui/icons-material/FolderOpenOutlined";

import classes from "./global-search.module.css";
import { GlobalSearchAccess, useGlobalSearchAccess } from "./global-search-utils";

interface HelpItem {
  icon: React.ReactNode;
  label: string;
  example: string;
  access: keyof Pick<GlobalSearchAccess, "finAdvisor" | "paymentHub">;
}

const HELP_ITEMS: HelpItem[] = [
  {
    icon: <PersonOutlineIcon fontSize="small" />,
    label: "Patient name, DOB, or email",
    example: "e.g. Chris Stone, 12/11/1999, chris@finpay.net",
    access: "finAdvisor",
  },
  {
    icon: <VerifiedUserOutlinedIcon fontSize="small" />,
    label: "VOB number",
    example: "e.g. #14265",
    access: "finAdvisor",
  },
  {
    icon: <RequestQuoteOutlinedIcon fontSize="small" />,
    label: "Estimate number",
    example: "e.g. #29104",
    access: "finAdvisor",
  },
  {
    icon: <AccountBalanceWalletOutlinedIcon fontSize="small" />,
    label: "Payment Hub (patient name)",
    example: "e.g. Chris Stone",
    access: "paymentHub",
  },
  {
    icon: <FolderOpenOutlinedIcon fontSize="small" />,
    label: "IOC number",
    example: "e.g. #28776",
    access: "finAdvisor",
  },
];

/** Explains what the single search bar accepts. */
const GlobalSearchHelp = () => {
  const access = useGlobalSearchAccess();
  const items = HELP_ITEMS.filter((item) => access[item.access]);

  return (
    <>
      <div className={classes.sectionLabel}>Search by</div>
      <div className={classes.helpList}>
        {items.map((item) => (
          <div className={classes.helpItem} key={item.label}>
            <span className={classes.helpIcon}>{item.icon}</span>
            <div>
              <Typography variant="body2">{item.label}</Typography>
              <div className={classes.helpExample}>{item.example}</div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default GlobalSearchHelp;
